// Third Party
import * as $ from "jquery";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

export default {
    name: "ModalViewDocument",
    mixins: [toastMessageMixins, userMixins],
    data() {
        return {
            documentUrl: "",
            description: "",
            fileType: "",
            isAPILoading: false,
            fileName: "",
            isImageType: false,
            isDownloading: false,

            isImageLoading: true,
            uniqueKey: Date.now(),
        };
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show(document, imageTypes = ["png", "jpeg", "jpg", "gif", "svg+xml", "svg"]) {
            const { documentUrl, type, name } = document;
            this.uniqueKey = Date.now(); // forces to rerender image(prevents caching that doesn't remove spinner)
            this.isImageLoading = true; 

            if (imageTypes.includes(type)) {
                this.isImageType = true;
            } else {
                this.isImageType = false;
            }

            this.fileName = name;
            this.fileType = type;
            this.documentUrl = documentUrl;

            $(this.$refs.modalViewDocument).modal("show");
        },
        hideModal() {
            $(this.$refs.modalViewDocument).modal("hide");
        },
        async downloadImage() {
            this.isDownloading = true;

            try {
                const image = await fetch(this.documentUrl);
                const imageBlob = await image.blob();
                const imageURL = URL.createObjectURL(imageBlob);

                const link = document.createElement("a");
                link.href = imageURL;
                link.download = this.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Revoke the object URL to free up memory
                URL.revokeObjectURL(imageURL);
            } catch (error) {
                console.error("Failed to download image:", error);
            } finally {
                this.isDownloading = false;
            }
        },
        onImageLoad(){
            this.isImageLoading = false;
        },
    },
};
